export const PHANTOM_CONFIG = {
  animation: 'shimmer' as const,
  reveal: 0.4,
  stagger: 0.05,
  duration: 1.6,
  count: 5,
  countGap: 4,
  shimmerColor: {
    light: 'rgba(189, 189, 201, 0.15)',
    dark: 'rgba(189, 189, 201, 0.08)',
  },
  backgroundColor: {
    light: 'rgba(189, 189, 201, 0.12)',
    dark: 'rgba(189, 189, 201, 0.06)',
  },
} as const;

/**
 * Returns phantom-ui props with the correct loading attribute handling.
 *
 * IMPORTANT: React sets boolean `false` as the string attribute `loading="false"`
 * on custom elements, but phantom-ui's CSS uses `phantom-ui[loading]` which
 * matches ANY value. Passing `undefined` removes the attribute entirely.
 */
export function phantomProps(isDark: boolean, loading?: boolean) {
  return {
    loading: loading || undefined,
    animation: PHANTOM_CONFIG.animation,
    reveal: PHANTOM_CONFIG.reveal,
    stagger: PHANTOM_CONFIG.stagger,
    duration: PHANTOM_CONFIG.duration,
    shimmerColor: isDark
      ? PHANTOM_CONFIG.shimmerColor.dark
      : PHANTOM_CONFIG.shimmerColor.light,
    backgroundColor: isDark
      ? PHANTOM_CONFIG.backgroundColor.dark
      : PHANTOM_CONFIG.backgroundColor.light,
  };
}
